// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/permissions.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/permissions.proto.
 */
export const file_proto_model_core_permissions = /*@__PURE__*/
  fileDesc("CiJwcm90by9tb2RlbC9jb3JlL3Blcm1pc3Npb25zLnByb3RvEgZjYXJtZW4iDQoLUGVybWlzc2lvbnNCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw");

/**
 * Describes the message carmen.Permissions.
 * Use `create(PermissionsSchema)` to create a new message.
 */
export const PermissionsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_permissions, 0);

